import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type {
  wxCodeAssistanceAnsibleState,
  wxCodeAssistanceAnsibleDispatch,
} from './store';

export const useWxCodeAssistanceAnsibleDispatch =
  (): wxCodeAssistanceAnsibleDispatch =>
    useDispatch<wxCodeAssistanceAnsibleDispatch>();
export const useWxCodeAssistanceAnsibleSelector: TypedUseSelectorHook<wxCodeAssistanceAnsibleState> =
  useSelector;
